var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { CpslButton, CpslCodeInput, CpslDivider, CpslIcon, CpslQrCode, CpslSpinner, CpslText, } from '@usecapsule/react-components';
import { useEffect, useRef, useState } from 'react';
import { useCapsuleStore, useModalStore } from '../../stores/index.js';
import { Heading, QRContainer, FilledDisabledInput, StepContainer, InnerStepContainer } from '../common.js';
import { ModalStep } from '../../utils/steps.js';
import { styled } from 'styled-components';
import { useCopyToClipboard } from '@usecapsule/react-common';
export const Setup2FAStep = ({ onClose }) => {
    const isLogin = useModalStore(state => state.isLogin());
    const setStep = useModalStore(state => state.setStep);
    const capsule = useCapsuleStore(state => state.capsule);
    const isVerifying = useModalStore(state => state.step === ModalStep.VERIFY_2FA);
    const [copied, copy] = useCopyToClipboard();
    const inputRef = useRef(null);
    const [qrCodeValue, setQrCodeValue] = useState(null);
    const [code, setCode] = useState('');
    const [codeError, setCodeError] = useState('');
    const [isVerifyingCode, setIsVerifyingCode] = useState(false);
    const params = qrCodeValue ? new URL(qrCodeValue).searchParams : undefined;
    const secret = params === null || params === void 0 ? void 0 : params.get('secret');
    useEffect(() => {
        function fetchOtpAuthUrl() {
            return __awaiter(this, void 0, void 0, function* () {
                try {
                    const { uri } = yield capsule.setup2FA();
                    setQrCodeValue(uri);
                }
                catch (error) {
                    console.error('Error fetching OTPAuth URL:', error);
                }
            });
        }
        fetchOtpAuthUrl();
    }, []);
    useEffect(() => {
        // Using a small timeout here to ensure the input is mounted before attempting focus
        setTimeout(() => {
            var _a, _b, _c;
            (_c = (_b = (_a = inputRef === null || inputRef === void 0 ? void 0 : inputRef.current) === null || _a === void 0 ? void 0 : _a.shadowRoot.querySelectorAll('input')) === null || _b === void 0 ? void 0 : _b[0]) === null || _c === void 0 ? void 0 : _c.focus();
        }, 10);
    }, [isVerifying]);
    useEffect(() => {
        if (code.length === 6) {
            handleSubmitCode();
        }
    }, [code]);
    const handleNext = () => {
        setStep(ModalStep.VERIFY_2FA);
    };
    const handleSkip = () => {
        if (isLogin) {
            setStep(ModalStep.LOGIN_DONE);
        }
        else {
            onClose();
        }
    };
    const handleCodeInput = (e) => {
        if (codeError) {
            setCodeError('');
        }
        setCode(e.detail.value.trim());
    };
    const handleSubmitCode = () => __awaiter(void 0, void 0, void 0, function* () {
        setIsVerifyingCode(true);
        if (code.length === 6 && /^\d+$/.test(code)) {
            try {
                yield capsule.enable2FA(code);
                setStep(ModalStep.TWO_FACTOR_DONE);
            }
            catch (e) {
                setCodeError('Incorrect Code');
            }
        }
        else {
            setCodeError('Incorrect Code');
        }
        setIsVerifyingCode(false);
    });
    const handleCopy = () => {
        copy(secret);
    };
    return (_jsxs(StepContainer, { children: [_jsxs(InnerStepContainer, { children: [_jsx(Heading, { variant: "headingS", weight: "bold", children: "Turn on Two-Factor authentication" }), isVerifying && (_jsx(CpslText, { variant: "bodyS", color: "secondary", weight: "medium", children: "Please enter the code from your authenticator app." }))] }), _jsx(InnerStepContainer, { children: isVerifying ? (_jsx(_Fragment, { children: isVerifyingCode ? (_jsx(CpslSpinner, {})) : (_jsx("form", { onSubmit: (e) => __awaiter(void 0, void 0, void 0, function* () {
                            e.preventDefault();
                            yield handleSubmitCode();
                        }), children: _jsx(StyledCodeInput, { ref: inputRef, code: code, onCpslInput: handleCodeInput, errorText: codeError, length: 6, onKeyDown: (e) => __awaiter(void 0, void 0, void 0, function* () { return e.key === 'Enter' && (yield handleSubmitCode()); }) }) })) })) : (_jsxs(_Fragment, { children: [_jsx(CpslText, { variant: "bodyS", color: "secondary", weight: "medium", children: "Scan with your preferred authenticator app." }), _jsx(QRContainer, { children: !qrCodeValue ? _jsx(CpslSpinner, { size: 100 }) : _jsx(CpslQrCode, { url: qrCodeValue }) })] })) }), !isVerifying && (_jsxs(_Fragment, { children: [_jsx(InnerStepContainer, { children: _jsx(CpslDivider, { children: "or enter the code manually" }) }), _jsx(InnerStepContainer, { children: _jsx(FilledDisabledInput, { disabled: true, value: secret, noAutoDisable: true, children: _jsx(CpslButton, { slot: "end", variant: "ghost", onClick: handleCopy, children: _jsx(CpslIcon, { icon: copied ? 'check' : 'copy' }) }) }) }), _jsxs(InnerStepContainer, { children: [_jsx(CpslButton, { fullWidth: true, onClick: handleNext, children: "Continue" }), _jsx(SkipButton, { variant: "ghost", onClick: handleSkip, children: "Skip" })] })] }))] }));
};
const StyledCodeInput = styled(CpslCodeInput) `
  align-self: center;
`;
const SkipButton = styled(CpslButton) `
  margin-top: 8px;
  text-decoration: underline;
`;
